import React from "react";
import { observer } from "mobx-react";
import Link from "./Link";
import { useStores } from "../helpers";

const ArticleLink = observer(({ children, ...props }) => {
  const { ArticleStore } = useStores();

  const disableSponsoredExtra = ArticleStore.article?.disableSponsoredExtra;
  const disableNoFollowExtra = ArticleStore.article?.disableNofollowExtra;

  return (
    <Link
      {...props}
      disableSponsoredExtra={disableSponsoredExtra}
      disableNoFollowExtra={disableNoFollowExtra}
    >
      {children}
    </Link>
  );
});

export default ArticleLink;